'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSearchBox } from 'react-instantsearch';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import IconSearch from 'components/icons/IconSearch';
import { colorGrayLight2 } from 'styles/layout/colors';
const CategorySearchBox = t0 => {
  const $ = _c(7);
  const {
    pageName: t1
  } = t0;
  const pageName = t1 === undefined ? "" : t1;
  const {
    refine
  } = useSearchBox();
  const [inputValue, setInputValue] = useState("");
  let t2;
  if ($[0] !== refine) {
    t2 = event => {
      const value = event?.target?.value;
      setInputValue(value);
      refine(value);
    };
    $[0] = refine;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleChange = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconSearch color={colorGrayLight2} height={20} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `Search ${pageName}`;
  const t5 = inputValue ?? null;
  let t6;
  if ($[3] !== handleChange || $[4] !== t4 || $[5] !== t5) {
    t6 = <LabeledTextInput action={t3} actionAlignment="left" label={t4} labelSize="sm" noMargin={true} onChange={handleChange} value={t5} />;
    $[3] = handleChange;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
CategorySearchBox.propTypes = {
  pageName: PropTypes.string
};
export default CategorySearchBox;